import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ServicesService } from '../services/services.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-shop-admin',
  templateUrl: './shop-admin.component.html',
  styleUrls: ['./shop-admin.component.css']
})
export class ShopAdminComponent implements OnInit {

  myUrl;
  isLoading: number = 0;

  constructor(private _services: ServicesService, private router: Router,private formBuilder: FormBuilder, public siteUrl: DomSanitizer) {
    this.isLoading = 0;
  }

  ngOnInit() {
    this._services.checkToken('status');
    // this.token = localStorage.getItem('userToken');
    this.myUrl = this.siteUrl.bypassSecurityTrustResourceUrl("https://amalooloo.shop/wp-admin/");
  }
  
  myLoadEvent() { 
    //console.log("here???", this.isLoading)
    this.isLoading++;
  }
}
